var map = {
	"./ios_ar.png": "f0ec",
	"./ios_bn.png": "244a",
	"./ios_en.png": "801f",
	"./ios_es.png": "2dca",
	"./ios_fil.png": "7f7e",
	"./ios_fr.png": "c4309",
	"./ios_ha.png": "7e5e",
	"./ios_hi.png": "0687",
	"./ios_id.png": "6389",
	"./ios_ig.png": "b7da",
	"./ios_it.png": "1a5f",
	"./ios_ja.png": "7218",
	"./ios_kk.png": "7898",
	"./ios_ko.png": "48a1",
	"./ios_ku.png": "0546",
	"./ios_ms.png": "0746",
	"./ios_pa.png": "b7ea",
	"./ios_ps.png": "61b4",
	"./ios_pu.png": "98be",
	"./ios_ru.png": "68e0",
	"./ios_ta.png": "c36b",
	"./ios_te.png": "b835",
	"./ios_th.png": "5116",
	"./ios_tr.png": "d26c",
	"./ios_tw.png": "a1c8",
	"./ios_uk.png": "933a",
	"./ios_ur.png": "b53a",
	"./ios_vi.png": "2896",
	"./ios_yo.png": "756d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b40";